export default "__VITE_ASSET__BbnC$Dpx__"